import { useEffect, useState } from "react";
import API from "../../../services/api";
import "./resultFileList.css";

export default function ResultFileList() {

  const schoolAdmin = JSON.parse(localStorage.getItem("schoolAdmin"));
  const schoolId = schoolAdmin?.school?.id;

  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [actionId, setActionId] = useState(null);

  useEffect(() => {
    if (schoolId) {
      fetchFiles();
    }
  }, [schoolId]);

  // ================================
  // FETCH FILES
  // ================================
  const fetchFiles = async () => {

    try {

      setLoading(true);
      setError("");

      const res = await API.get(
        "/school-admin/results/files/",
        {
          headers: { "X-SCHOOL-ID": schoolId }
        }
      );

      setFiles(res.data?.uploads || []);

    } catch (err) {

      console.error(err);
      setError("Failed to load result files");
      setFiles([]);

    } finally {

      setLoading(false);

    }

  };

  // ================================
  // DELETE FILE
  // ================================
  const deleteFile = async (id) => {

    if (!window.confirm("Delete this result file?")) return;

    try {

      setActionId(id);

      await API.delete(
        `/school-admin/results/files/delete/${id}/`,
        {
          headers: { "X-SCHOOL-ID": schoolId }
        }
      );

      fetchFiles();

    } catch (err) {

      console.error(err);
      alert("Failed to delete file");

    } finally {

      setActionId(null);

    }

  };

  // ================================
  // FILE URL
  // ================================
  const getFileUrl = (filePath) => {

    if (!filePath) return null;

    if (filePath.startsWith("http")) {
      return filePath;
    }

    const base = API.defaults.baseURL.replace(/\/$/, "");

    return `${base}${filePath}`;
  };

  return (

    <div className="result-container">

      {/* HEADER */}

      <div className="result-header">

        <h2 className="page-title">
          Uploaded Result Files
        </h2>

        <button
          className="refresh-btn"
          onClick={fetchFiles}
        >
          🔄 Refresh
        </button>

      </div>

      {/* CARD */}

      <div className="result-card">

        {loading ? (

          <div className="no-data">
            Loading files...
          </div>

        ) : error ? (

          <div className="no-data error">
            {error}
          </div>

        ) : files.length === 0 ? (

          <div className="no-data">
            No files uploaded yet
          </div>

        ) : (

          <table className="result-table">

            <thead>
              <tr>
                <th>Exam</th>
                <th>File</th>
                <th>Uploaded</th>
                <th style={{width:"120px"}}>Action</th>
              </tr>
            </thead>

            <tbody>

              {files.map((f) => (

                <tr key={f.id}>

                  <td>{f.exam || "-"}</td>

                  <td>

                    {getFileUrl(f.file) ? (

                      <a
                        href={getFileUrl(f.file)}
                        target="_blank"
                        rel="noreferrer"
                        className="btn-download"
                      >
                        📄 View File
                      </a>

                    ) : (

                      "-"

                    )}

                  </td>

                  <td>
                    {f.uploaded_at || "-"}
                  </td>

                  <td>

                    <button
                      className="btn-download"
                      disabled={actionId === f.id}
                      onClick={() => deleteFile(f.id)}
                    >
                      Delete
                    </button>

                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        )}

      </div>

    </div>

  );

}